import { render } from "./TalentIdeal.vue?vue&type=template&id=632662f7"
import script from "./TalentIdeal.vue?vue&type=script&lang=js"
export * from "./TalentIdeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__